import { cn } from "@/lib/utils";
import FeatureChecklistItem from "./FeatureChecklistItem";

export default function PricingCard({
  name,
  price,
  priceSuffix,
  ctaLabel,
  ctaVariant = "dark", // "dark" | "outline"
  highlighted = false,
  blurb,
  featuresLead,
  features = [],
  onCtaClick,
}) {
  const ctaClasses = {
    dark: "bg-[#0E1430] text-white hover:bg-[#1A2150]",
    outline:
      "border border-[#0092B4] bg-white text-[#0092B4] hover:bg-[#0092B4] hover:text-white",
  };

  return (
    <div
      className={cn(
        "relative flex flex-col rounded-3xl bg-white p-6 ring-1 ring-neutral-200 sm:p-8",
        highlighted && "ring-2 ring-[#7B61FF] shadow-xl"
      )}
    >
      <p className="text-sm font-medium text-neutral-500">{name}</p>
      <div className="mt-4 flex items-baseline gap-1">
        <span className="text-4xl font-semibold tracking-tight text-neutral-900">{price}</span>
        {priceSuffix && (
          <span className="text-sm text-neutral-500">{priceSuffix}</span>
        )}
      </div>
      <button
        type="button"
        onClick={onCtaClick}
        className={cn(
          "mt-6 inline-flex h-11 items-center justify-center rounded-full px-5 text-sm font-medium transition-colors",
          ctaClasses[ctaVariant]
        )}
      >
        {ctaLabel}
      </button>
      {blurb && <p className="mt-5 text-sm text-neutral-500">{blurb}</p>}
      {featuresLead && (
        <p className="mt-4 text-sm font-medium text-neutral-700">{featuresLead}</p>
      )}
      <ul className="mt-3 space-y-2.5">
        {features.map((feature) => (
          <FeatureChecklistItem key={feature}>{feature}</FeatureChecklistItem>
        ))}
      </ul>
    </div>
  );
}
